<template>
    <div id="graficoContainer">
        <span class="TituloGrafico" v-if="hasTitulo">{{titulo}}</span>
        <div :id="uuid" class="treeMap" ref="treeMap"></div>
    </div>
</template>

<script>

import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'
import MetodosGlobais from '@/utils/MetodosGlobais'
import CorUtil from '@/utils/CorUtils'

am4core.useTheme(am4themes_animated)
let uuid = 0

export default {
  name: 'grafico-tree',

  beforeCreate () {
    this.uuid = uuid.toString()
    uuid += 1
  },

  mounted () {
    this.chart = am4core.create(this.uuid, am4charts.TreeMap)
    this.chart.hiddenState.properties.opacity = 0 // this makes initial fade in effect
    this.chart.data = this.processData(this.dados)

    // only one level visible initially
    this.chart.maxLevels = 0
    // define data fields
    this.chart.dataFields.value = 'count'
    this.chart.dataFields.name = 'name'
    this.chart.dataFields.children = 'children'
    this.chart.homeText = ''

    // enable navigation
    this.chart.navigationBar = new am4charts.NavigationBar()

    // level 0 series template
    let level0SeriesTemplate = this.chart.seriesTemplates.create('0')
    level0SeriesTemplate.strokeWidth = 2
    level0SeriesTemplate.columns.template.tooltipText = '{name}: {totalizador}'

    let bullet0 = level0SeriesTemplate.bullets.push(new am4charts.LabelBullet())
    bullet0.locationX = 0.5
    bullet0.locationY = 0.5
    bullet0.label.text = '{name} - {totalizador}'
    bullet0.label.fill = am4core.color('#ffffff')
    bullet0.interactionsEnabled = false

    // create hover state
    let columnTemplate = level0SeriesTemplate.columns.template
    let hoverState = columnTemplate.states.create('hover')

    // darken
    hoverState.adapter.add('fill', function (fill, target) {
      if (fill instanceof am4core.Color) {
        return am4core.color(am4core.colors.brighten(fill.rgb, -0.2))
      }
      return fill
    })

    // level1 series template
    let level1SeriesTemplate = this.chart.seriesTemplates.create('1')
    level1SeriesTemplate.columns.template.fillOpacity = 0
    level1SeriesTemplate.columns.template.tooltipText = '{parentName} - {name}: {value}'

    let bullet1 = level1SeriesTemplate.bullets.push(new am4charts.LabelBullet())
    bullet1.locationX = 0.5
    bullet1.locationY = 0.5
    bullet1.label.text = '{name} - {value}'
    bullet1.label.fill = am4core.color('#ffffff')
    bullet1.interactionsEnabled = false

    // level2 series template
    let level2SeriesTemplate = this.chart.seriesTemplates.create('2')
    level2SeriesTemplate.columns.template.fillOpacity = 0

    let bullet2 = level2SeriesTemplate.bullets.push(new am4charts.LabelBullet())
    bullet2.locationX = 0.5
    bullet2.locationY = 0.5
    bullet2.label.text = '{name}'
    bullet2.label.fill = am4core.color('#ffffff')
    bullet2.interactionsEnabled = false
  },
  beforeDestroy () {
    if (this.chart) { this.chart.dispose() }
  },
  data: () => {
    return {
      chart: null,
      grafico: null,
    }
  },
  props: {
    titulo: {
      type: String,
      default: '',
    },
    cores: {
      type: Array,
      default: () => [],
    },
    dados: {
      type: Array,
      default: () => [],
    },
    rangePorcentagem: {
      type: Array,
      default: () => [],
    },
    // Define o menor valor de uma categoria, se for muito pequena será jogada para um grupo "Outros"
    lowerLimit: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    carregamentoInicial (dados) {
      this.chart.data = this.processData(dados)
    },
    refreshDados (dados) {
    },
    processData (data) {
      let treeData = []

      let smallSubs = {
        name: 'Other',
        children: [],
      }

      data.forEach(sub => {
        let subData = {
          name: sub.nome,
          totalizador: sub.totalizador,
          children: [],
        }

        let subTotal = 0
        if (sub.dados) {
          for (let serv in sub.dados) {
            subTotal += sub.dados[serv]
          }

          for (let serv in sub.dados) {
          // do not add very small
            if (sub.dados[serv] > this.lowerLimit) {
              subData.children.push({
                name: serv,
                count: sub.dados[serv],
              })
            }
          }

          this.chart.maxLevels = 1
          // add to small brands if total number less than
        } else {
          subTotal = sub.totalizador
          this.chart.maxLevels = 0
        }
        if (subTotal > this.lowerLimit) {
          treeData.push(subData)
        } else {
          smallSubs.children.push(subData)
        }
      })

      return treeData
    },
  },
  computed: {
    hasTitulo: function () {
      if (this.titulo) { return true }
      return false
    },
  },
}
</script>

<style scoped>
  .tituloGrafico {
    font-size: 24px;
  }

  #graficoContainer{
       width: 100%;
  }
  .treeMap {
      height: 90%;
  }
  @media (min-width: 561px) and (max-width: 999px) {
    .treeMap {
      min-height: 300px;
    }
  }

</style>
